import React from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import classnames from 'classnames/bind'
import { formatLocation } from '../../converters/location'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const NearbyAssetTotals = ({ filters, elmId, nearbyTotal }) => {
  const nearLocation = formatLocation(filters)
  return (
    <div className={cx('u-ml-3')} data-elm-id={elmId}>
      <div className={cx('asset-totals')}>
        <div className={cx('description')} data-elm-id={`${elmId}_label`}>
          <span data-elm-id={`${elmId}_nearby_count`}>
            {nearbyTotal.toLocaleString('en')}
          </span>
          {` ${pluralize('Property', nearbyTotal)} `}
          near{' '}
          <span data-elm-id={`${elmId}_nearby_location`}>{nearLocation}</span>
        </div>
      </div>
    </div>
  )
}

NearbyAssetTotals.propTypes = {
  filters: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
  nearbyTotal: PropTypes.number.isRequired,
}

export default NearbyAssetTotals
